import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColumnMenu } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import moreActions from "../../assets/moreActions.svg";
import "./DataTable.css";
import { useLocation, useNavigate } from "react-router-dom";

const DataTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [columnsVisible, setColumnsVisible] = useState(null);
  const dataGridRef = useRef(null); // Ref for the DataGrid


  const CustomButton = () => (
    <Button variant="outlined" className="moreButton">
      <div>
        <img src={moreActions} alt="More Actions" />
      </div>{" "}
      <div style={{ height: "14px" }}>More</div>
    </Button>
  );
  const handleRowClick = (params, event) => {
    event.preventDefault();
    if (location && location.pathname === "/users") {
      // navigate(`${params?.row?.batOneId}`, {
      //   state: { ...params.row, mode: "Edit" },
      // });
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        paddingTop: "2rem",
        overflowY: "auto", // Allow scrolling on the window
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        <DataGrid
          ref={dataGridRef} // Attach ref to DataGrid
          hideScrollbar={true}
          slots={{
            MoreActionsIcon: CustomButton,
            columnMenu: CustomColumnMenu,
          }}
          onRowClick={(p, e) => handleRowClick(p, e)}
          rows={props.rows}
          getRowId={(row) => row.ihLogId || row.id || row.farmerLogId || row.cropStageCalendarUid || Math.random()}
          columns={props.columns}
          rowCount={props.totalRowCount}
          paginationModel={props.paginationModel}
          paginationMode={props.useClientPagination ? "client" : "server"}
          hideFooterPagination={true}
          onPaginationModelChange={props.setPaginationModel}
          style={{ borderStyle: "none", height: "calc(100vh - 2rem)" }} // Adjust height
          sx={{
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#ffffff",
              position: "relative",
              marginTop: "10px",
              marginBottom: "10px",
              borderRadius: "10px",
              height: "4.688rem",
          // boxShadow: '2px 2px 10px 0px rgba(172, 180, 186, 0.3)',
              // width: "99.8%",
              maxHeight: "unset !important",
              alignItems: "center",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "unset",
              color: "rgba(59, 69, 79, 1)",
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "24.38px",
              letterSpacing: "0em",
              textAlign: "left",
              outline: "none !important",
            },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "#F5F5F7",
              justifyContent: "center",
              paddingBottom: "4rem",
              borderTop: "none",
              margin: "0px -26px" ,
            },
            "& .MuiDataGrid-columnHeaders": {
              border: "none",
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: 400,
              color: "#737D86",
              lineHeight: "24.38px",
            },
            // Remove virtual scroller styles since we're using window scroll
          }}
        />
      </div>
    </div>
  );
};

export default DataTable;

function CustomColumnMenu(props) {
  return (
    <GridColumnMenu
      {...props}
      slots={{
        columnMenuColumnsItem: null,
      }}
    />
  );
}
